import { render } from "./search-nav.vue?vue&type=template&id=53d3b7e9&scoped=true"
import script from "./search-nav.vue?vue&type=script&lang=js"
export * from "./search-nav.vue?vue&type=script&lang=js"

import "./search-nav.vue?vue&type=style&index=0&id=53d3b7e9&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53d3b7e9"]])

export default __exports__